import { action } from 'satcheljs/lib/legacy';
import FindControlViewState from 'owa-recipient-common/lib/store/schema/FindControlViewState';

export default action('setForceResolveState')(function setForceResolveState(
    viewstate: FindControlViewState,
    inForceResolve: boolean
) {
    viewstate.inForceResolve = inForceResolve;
});
